"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultAnalystRatingProps = exports.HocAnalystRating = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require("recompose");

var _ramda = require("ramda");

var _analyst_rating = require("../../components/analyst_rating");

var _analyst_rating2 = _interopRequireDefault(_analyst_rating);

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HocAnalystRating = exports.HocAnalystRating = (0, _ramda.compose)((0, _recompose.mapProps)(function (_ref) {
  var fund = _ref.fund,
      breakpoint = _ref.breakpoint,
      useTooltipWrapper = _ref.useTooltipWrapper,
      gaiaRedirectUrl = _ref.gaiaRedirectUrl,
      intl = _ref.intl,
      isAEM = _ref.isAEM;

  return _extends({}, getDefaultAnalystRatingProps({ fund: fund, breakpoint: breakpoint, gaiaRedirectUrl: gaiaRedirectUrl, intl: intl, isAEM: isAEM }), {
    useTooltipWrapper: useTooltipWrapper
  });
}))((0, _reactIntl.injectIntl)(_analyst_rating2.default, { withRef: true }));

var getDefaultAnalystRatingProps = exports.getDefaultAnalystRatingProps = function getDefaultAnalystRatingProps(_ref2) {
  var fund = _ref2.fund,
      breakpoint = _ref2.breakpoint,
      _ref2$gaiaRedirectUrl = _ref2.gaiaRedirectUrl,
      gaiaRedirectUrl = _ref2$gaiaRedirectUrl === undefined ? "" : _ref2$gaiaRedirectUrl,
      isAEM = _ref2.isAEM;

  return {
    morningstarRating: fund.shareClass.morningstarRating,
    morningstarOverallRating: fund.shareClass.morningstarOverallRating,
    breakpoint: breakpoint,
    isAEM: isAEM,
    disclosure: fund.disclosures[fund.shareClass.cusip] ? fund.disclosures[fund.shareClass.cusip] : fund.disclosures,
    gaiaRedirectUrl: gaiaRedirectUrl,
    additionalClassName: "",
    visibleData: fund.visibleData
  };
};